var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('span',{staticClass:"todo-count"},[_vm._v("合 计:"),_c('strong',[_vm._v(" "+_vm._s(_vm.list.length)+" ")])]),_c('button',{staticClass:"clear-completed",on:{"click":_vm.clean}},[_vm._v(" 清空任务 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }